module.exports = __webpack_public_path__ + "static/media/025_g3_2Gettings Started 3.4754d7e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/gigable/025_g3_2Gettings Started 3.png
// module id = 445
// module chunks = 0